import React from 'react';
import { Card } from 'shared-components';
import EsignUS from './EsignUS';

export default () => (
  <Card>
    <EsignUS />
  </Card>
);
